/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReserveClubhouseRequestData } from './ReserveClubhouseRequestData';
import {
    ReserveClubhouseRequestDataFromJSON,
    ReserveClubhouseRequestDataFromJSONTyped,
    ReserveClubhouseRequestDataToJSON,
} from './ReserveClubhouseRequestData';
import type { Metadata } from './Metadata';
import {
    MetadataFromJSON,
    MetadataFromJSONTyped,
    MetadataToJSON,
} from './Metadata';

/**
 * 
 * @export
 * @interface ListClubhouseRequestDataForAccount200Response
 */
export interface ListClubhouseRequestDataForAccount200Response {
    /**
     * 
     * @type {Array<ReserveClubhouseRequestData>}
     * @memberof ListClubhouseRequestDataForAccount200Response
     */
    data: Array<ReserveClubhouseRequestData>;
    /**
     * 
     * @type {Metadata}
     * @memberof ListClubhouseRequestDataForAccount200Response
     */
    metadata: Metadata;
}

/**
 * Check if a given object implements the ListClubhouseRequestDataForAccount200Response interface.
 */
export function instanceOfListClubhouseRequestDataForAccount200Response(value: object): value is ListClubhouseRequestDataForAccount200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('metadata' in value) || value['metadata'] === undefined) return false;
    return true;
}

export function ListClubhouseRequestDataForAccount200ResponseFromJSON(json: any): ListClubhouseRequestDataForAccount200Response {
    return ListClubhouseRequestDataForAccount200ResponseFromJSONTyped(json, false);
}

export function ListClubhouseRequestDataForAccount200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListClubhouseRequestDataForAccount200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ReserveClubhouseRequestDataFromJSON)),
        'metadata': MetadataFromJSON(json['metadata']),
    };
}

export function ListClubhouseRequestDataForAccount200ResponseToJSON(value?: ListClubhouseRequestDataForAccount200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ((value['data'] as Array<any>).map(ReserveClubhouseRequestDataToJSON)),
        'metadata': MetadataToJSON(value['metadata']),
    };
}

